import * as yup from 'yup';
import { emailSchema } from '../../../utils/validation';

const rules = yup.object({
  email: emailSchema(),
});

export default rules;
